import { RouteObject } from 'react-router-dom';
import Services from '../Services';
import ViewService from '../pages/ViewService/ViewService';
import EditService from '../pages/EditService/EditService';
import NewService from '../pages/NewService/NewService';

export const ServicesRoutes: RouteObject[] = [
  {
    path: 'services/new',
    element: <NewService />,
  },
  {
    path: 'services/:serviceId/edit',
    element: <EditService />,
  },
  {
    path: 'services/:serviceId',
    element: <ViewService />,
  },
  {
    path: 'services',
    element: <Services />,
  },
];
